import Seta from '@assets/images/Seta.svg';
import PlaceholderImage from '@assets/images/img-final-home-02.png';
import { Link } from 'react-router-dom';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './SectionTwo.style';
import { useTranslation } from 'react-i18next';

const SectionTwo = () => {
  const { t } = useTranslation('home');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>
          AdServer C<span>2</span>Audit
        </h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox1>
          <div className="text-content">
            <p>{t('sectionTwo.paragraphOne')}</p>
          </div>
        </TextBox1>

        <TextBox2>
          <p>{t('sectionTwo.paragraphTwo')}</p>
          <Link to="/audit" className="link-with-icon">
            {t('sectionTwo.link')}
            <div>
              <img src={Seta} alt="Saiba Mais" />
            </div>
          </Link>
        </TextBox2>
        <ImageBox>
          <img src={PlaceholderImage} alt="Imagem" />
        </ImageBox>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default SectionTwo;
